import mount from "core/mount"
import { Toaster } from "@kit/design/toast"

mount({ Toaster })
